import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductIShieldSIO } from '../../actions'
import { getSelectableProductiShieldSIO } from 'quick-quote/product-sio/coverage-plan/selectors'
import { getSelectedDisplayProductCode } from '../../../../quick-quote/product-selection/selectors'
import VALUES from '../../../../core/data-model/constants/values'

export const IShieldSIOProductSelection = ({
  getSelectedDisplayProductCode,
  getSelectableProductiShieldSIO,
  selectedProductIShieldSIO,
}) => {
  const selectableProductIshieldSIO = getSelectableProductiShieldSIO
  const productIShieldSIO = [
    {
      text: '5 ปี',
      value: VALUES.ISHIELD_SIO_CODE.ISHIELD_5_SIO,
      canSelectable: selectableProductIshieldSIO.includes(VALUES.ISHIELD_SIO_CODE.ISHIELD_5_SIO),
    },
    {
      text: '10 ปี',
      value: VALUES.ISHIELD_SIO_CODE.ISHIELD_10_SIO,
      canSelectable: selectableProductIshieldSIO.includes(VALUES.ISHIELD_SIO_CODE.ISHIELD_10_SIO),
    },
    {
      text: '15 ปี',
      value: VALUES.ISHIELD_SIO_CODE.ISHIELD_15_SIO,
      canSelectable: selectableProductIshieldSIO.includes(VALUES.ISHIELD_SIO_CODE.ISHIELD_15_SIO),
    },
    {
      text: '20 ปี',
      value: VALUES.ISHIELD_SIO_CODE.ISHIELD_20_SIO,
      canSelectable: selectableProductIshieldSIO.includes(VALUES.ISHIELD_SIO_CODE.ISHIELD_20_SIO),
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectedProductIShieldSIO}
        value={getSelectedDisplayProductCode}
        options={productIShieldSIO}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedDisplayProductCode: getSelectedDisplayProductCode(state),
  getSelectableProductiShieldSIO: getSelectableProductiShieldSIO(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectedProductIShieldSIO: bindActionCreators(selectProductIShieldSIO, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(IShieldSIOProductSelection)
